import { useState } from 'react';
import './styles/global.css';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import AuthModal from './components/AuthModal';
import HomePage from './pages/HomePage';
import CheckoutPage from './pages/CheckoutPage';

export default function App() {
  const [cartOpen, setCartOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');
  const [activeCategory, setActiveCategory] = useState('all');
  const [showCheckout, setShowCheckout] = useState(false);

  const handleNavigate = (page) => {
    setShowCheckout(false);
    setCurrentPage(page);
    if (page === 'products') {
      setTimeout(() => {
        document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else if (page === 'story') {
      setTimeout(() => {
        document.getElementById('our-story')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else if (page === 'contact') {
      setTimeout(() => {
        document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleCheckout = () => {
    setShowCheckout(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <AuthProvider>
      <CartProvider>
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Navbar
            onCartClick={() => setCartOpen(true)}
            onAuthClick={() => setAuthOpen(true)}
            onNavigate={handleNavigate}
            currentPage={currentPage}
          />
          <main style={{ flex: 1 }}>
            {showCheckout ? (
              <CheckoutPage
                onBack={() => setShowCheckout(false)}
                onSuccess={() => {
                  setShowCheckout(false);
                  handleNavigate('home');
                }}
              />
            ) : (
              <HomePage
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
              />
            )}
          </main>
          {!showCheckout && <Footer />}
          <CartDrawer
            open={cartOpen}
            onClose={() => setCartOpen(false)}
            onCheckout={handleCheckout}
          />
          <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
        </div>
      </CartProvider>
    </AuthProvider>
  );
}
